import React, { useState, useRef, useEffect } from "react";
import { useI18n } from "../contexts/I18nContext";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang, languages } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClick(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const current = languages[lang];

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center gap-1.5 rounded-lg border border-sensoria-border px-2.5 py-1.5 text-xs font-medium text-sensoria-text-dim transition-colors hover:border-sensoria-muted hover:text-white"
      >
        <span>{current.flag}</span>
        {!compact && <span>{current.label}</span>}
        <svg className={`h-3 w-3 transition-transform ${open ? "rotate-180" : ""}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute right-0 top-full z-50 mt-1 min-w-[140px] overflow-hidden rounded-xl border border-sensoria-border bg-sensoria-card shadow-xl animate-fade-in">
          {Object.entries(languages).map(([code, { label, flag }]) => (
            <button
              key={code}
              onClick={() => { setLang(code); setOpen(false); }}
              className={`flex w-full items-center gap-2.5 px-3 py-2.5 text-left text-sm transition-colors ${
                code === lang
                  ? "bg-sensoria-accent/10 text-sensoria-accent-light"
                  : "text-sensoria-text-dim hover:bg-sensoria-surface hover:text-white"
              }`}
            >
              <span className="text-base">{flag}</span>
              <span>{label}</span>
              {code === lang && <span className="ml-auto text-sensoria-accent">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
